// extracted by mini-css-extract-plugin
export default {"corpoContainer":"mobile_corpoContainer__aNbeq"};